import React from 'react';
import { FiDroplet } from 'react-icons/fi';
import tnsLogo from '../../../assets/images/tnslogo.png';

const OPTReceipt = ({ onYes, onNo, onEmail, onSms, amount }) => {
  const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=60x60&data=${encodeURIComponent('https://www.tnsi.com')}`;

  return (
    <div className="bg-white text-gray-800 h-full flex flex-col overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-between px-3 py-2 border-b border-gray-100 flex-shrink-0">
        <div className="flex items-center space-x-1.5">
          <div className="w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center">
            <FiDroplet className="w-3 h-3 text-white" />
          </div>
          <span className="font-bold text-gray-800 text-xs">Fuel Co</span>
        </div>
        <div className="flex items-center space-x-1">
          <span className="text-[10px] text-gray-400">Powered by</span>
          <img src={tnsLogo} alt="TNS" className="h-4" />
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 flex flex-col px-3 py-2">
        <div className="text-xs font-bold text-center mb-2">Transaction Receipt</div>
        
        {/* Mini receipt */}
        <div className="border-2 border-gray-300 rounded-lg p-3 text-[9px] font-mono mb-2 flex-1 shadow-sm">
          <div className="text-center font-bold">RECEIPT</div>
          <div className="text-center">{'='.repeat(18)}</div>
          <div>DATE: {new Date().toLocaleDateString()}</div>
          <div>TIME: {new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}</div>
          <div>CARD: ****1234</div>
          <div>AMOUNT: ${amount || '0.00'}</div>
          <div>APPROVAL: 123456</div>
          <div>REF: {Math.random().toString(36).substr(2, 6).toUpperCase()}</div>
          <div className="text-center">{'='.repeat(18)}</div>
          <div className="text-center">THANK YOU</div>
          <div className="flex justify-center mt-1">
            <img src={qrCodeUrl} alt="QR" className="w-8 h-8" />
          </div>
        </div>

        {/* Buttons */}
        <div className="grid grid-cols-2 gap-2">
          <button onClick={onYes}
            className="py-2 bg-blue-600 text-white font-semibold text-xs rounded-lg hover:bg-blue-700">
            Print
          </button>
          <button onClick={onEmail}
            className="py-2 bg-blue-600 text-white font-semibold text-xs rounded-lg hover:bg-blue-700">
            Email
          </button>
          <button onClick={onSms}
            className="py-2 bg-blue-600 text-white font-semibold text-xs rounded-lg hover:bg-blue-700">
            SMS
          </button>
          <button onClick={onNo}
            className="py-2 bg-blue-600 text-white font-semibold text-xs rounded-lg hover:bg-blue-700">
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default OPTReceipt;
